import { useEffect, useState } from 'react';

interface Props<T> {
    value: T;
    delay: number;
    customHandler?: (value: T) => void;
    trigger?: (value: T) => boolean;
    onDebounce?: (value: T) => void;
}

const useDebounce = <T>({ value, delay, customHandler, trigger, onDebounce }: Props<T>) => {
    const [debounceValue, setDebounceValue] = useState(value);

    useEffect(() => {
        if (!trigger || trigger?.(debounceValue)) {
            const handler = setTimeout(() => {
                if (customHandler) {
                    customHandler(value);
                } else {
                    setDebounceValue(value);
                    onDebounce?.(value);
                }
            }, delay);

            return () => {
                clearTimeout(handler);
            };
        }
    }, [value, delay, customHandler, trigger, onDebounce, debounceValue]);

    return debounceValue;
};

export { useDebounce };
